"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YESTERDAY = exports.YEARTODATE = exports.THISMONTH = exports.ONEWEEK = exports.LAST_7_DAYS = exports.LAST_30_DAYS = exports.LAST_12_MONTHS = exports.LASTSIXMONTHS = exports.LASTMONTH = exports.HOURLY = exports.CUSTOM = exports.ALLTIME = void 0;
var YESTERDAY = 'YESTERDAY';
exports.YESTERDAY = YESTERDAY;
var LAST_7_DAYS = 'LAST_7_DAYS';
exports.LAST_7_DAYS = LAST_7_DAYS;
var LAST_30_DAYS = 'LAST_30_DAYS';
exports.LAST_30_DAYS = LAST_30_DAYS;
var LAST_12_MONTHS = 'LAST_12_MONTHS';
exports.LAST_12_MONTHS = LAST_12_MONTHS;
var HOURLY = 'HOURLY';
exports.HOURLY = HOURLY;
var ALLTIME = 'ALL TIME';
exports.ALLTIME = ALLTIME;
var CUSTOM = 'CUSTOM'; // old constants used for MSR charts

exports.CUSTOM = CUSTOM;
var ONEWEEK = 'ONE WEEK';
exports.ONEWEEK = ONEWEEK;
var THISMONTH = 'THIS MONTH';
exports.THISMONTH = THISMONTH;
var LASTMONTH = 'LAST MONTH';
exports.LASTMONTH = LASTMONTH;
var LASTSIXMONTHS = 'LAST SIX MONTHS';
exports.LASTSIXMONTHS = LASTSIXMONTHS;
var YEARTODATE = 'YEAR TO DATE';
exports.YEARTODATE = YEARTODATE;